import { STUDIO_HUB_PATH_PR } from '@home/pages/studio/constant';

/** PR 工作台子 Tab 仅前端状态，不写入 URL；路径只到 `/studio/:id/pr/:gameCode`。 */
export const PR_HUB_TAB_IDS = [
  'overview',
  'media',
  'regions',
  'articles',
  'posts',
  'videos',
  'streams',
] as const;

export type TPrHubTabId = (typeof PR_HUB_TAB_IDS)[number];

export const PR_HUB_TAB_ID_SET = new Set<string>(PR_HUB_TAB_IDS);

/** 构建 `/studio/:studioId/<hub>/:gameCode`（侧栏枢纽共用；无 Tab 段、无 query） */
export function buildSidebarHubGamePath(
  studioId: string,
  hubRootPath: string,
  gameCode: string,
): string {
  const seg = hubRootPath.replace(/^\//, '');
  return `/studio/${studioId}/${seg}/${encodeURIComponent(gameCode)}`;
}

/** 构建 `/studio/:studioId/pr/:gameCode`（无 Tab 段、无 query） */
export function buildPrHubGamePath(studioId: string, gameCode: string): string {
  return buildSidebarHubGamePath(studioId, STUDIO_HUB_PATH_PR, gameCode);
}

/** PrWorkspaceTabs 顶栏右侧工具区 DOM id（PrMediaTable 用 createPortal 挂载搜索/下载，无 Context） */
export const PR_WORKSPACE_TABS_TOOLBAR_HOST_ID = 'pr-workspace-tabs-toolbar-host' as const;
